import { TModelsData, TModelsListingFields, TModelsListingProps } from '../types/modelsListing.types';

export class ModelsListingModel {
  private readonly fields: null | TModelsListingFields;

  constructor(props: TModelsListingProps) {
    this.fields = props?.fields || null;
  }

  get modelsListData(): TModelsData | undefined {
    return this.fields?.apiData;
  }

  get url(): string | undefined {
    return this.fields?.itemData?.contextItemUrl;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
